module.exports = __webpack_public_path__ + "img/9.dbb4c1f7.jpg";